import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useNavigate, useParams } from "react-router-dom";
import { useOrder } from "../../hooks/useOrder";
import { MainButton } from "../MainButton";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
import api from "../../services/api";
import "./index.css";
import { cepNoMask, telephoneNoMask } from "../../functions/mask";
import { usePluginspace } from "../../hooks/usePluginspace";
import { OrderType } from "../../contexts/OrderContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useSeller } from "../../hooks/useSeller";
import { getHotelDeliveryPrefill } from "../../functions/util";

type ModalDeliveryProps = {
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
	backgroundButton?: string;
	fontButton?: string;
	goCustomer?: boolean;
	addressMapLocation?: AddressMapType | null;
};

type AddressLocationType = {
	cep: string;
	city: string;
	district: string;
	extra: string;
	number: string;
	state: string;
	street: string;
};

type LocationResponseType = {
	address: AddressLocationType;
	type: string;
	name: string;
	code: string;
};

export type AddressMapType = {
	city: string;
	state: string;
	street: string;
	district: string;
	cep: string;
	streetNumber: string;
	latLng?: {
		latitude: number;
		longitude: number;
	}
}

export function ModalDelivery({
	isOpen,
	setIsOpen,
	backgroundButton,
	fontButton,
	goCustomer = true,
	addressMapLocation,
}: ModalDeliveryProps) {
	const navigate = useNavigate();
	const { pluginspace_id } = useParams();
	const {
		setType,
		setOrderAddress,
		getOrder,
		setLocationId,
		customerAdress,
		changeCustomerAdress,
		changeAddressDelivery,
		getAddressDelivery
	} = useOrder();
	const orderContext = useOrder();
	const { getToken, getThisPluginspace, getLocations } = usePluginspace();
	const { getAppConfig } = useAppConfig();

	const [cep, setCep] = useState("");
	const [address, setAddress] = useState("");
	const [district, setDistrict] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [number, setNumber] = useState("");
	const [ibge, setIbge] = useState("");
	const [complement, setComplement] = useState("");
	const [reference, setReference] = useState("");
	const [name, setName] = useState("");
	const [telephone, setTelephone] = useState("");
	const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");

	const [alarmCep, setAlarmCep] = useState(false);
	const [alarmAddress, setAlarmAddress] = useState(false);
	const [alarmDistrict, setAlarmDistrict] = useState(false);
	const [alarmCity, setAlarmCity] = useState(false);
	const [alarmState, setAlarmState] = useState(false);
	const [alarmNumber, setAlarmNumber] = useState(false);
	const [alarmName, setAlarmName] = useState(false);
	const [alarmTelephone, setAlarmTelephone] = useState(false);
	const [isSeller, setIsSeller] = useState(false);

	const [alarmComplement, setAlarmComplement] = useState(false);

	const [loading, setLoading] = useState(false);
	const [lockHotelAddress, setLockHotelAddress] = useState(false);

	const { getTokenSeller } = useSeller();

	async function goToCustomer() {
		if (telephone.includes("_")) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Telefone inválido",
			});
			setTelephone("");
			return;
		}

		if (cep.includes("_")) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "CEP inválido",
			});
			setCep("");
			return;
		}

		if (!address) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Informe a rua de entrega",
			});
			return;
		}

		if (!district) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Informe o bairro de entrega",
			});
			return;
		}

		if (!city) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Informe a cidade de entrega",
			});
			return;
		}

		if (!number) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Informe o número do endereço de entrega",
			});
			return;
		}

		if (!complement && isSeller) {
			Swal.fire({
				icon: "warning",
				title: "Atenção!",
				text: "Informe o nome do endereço",
			});
			return;
		}

		const cepOk = await isCepOk(cep);
		if (!cepOk) return;

		if (cep && address && district && city && number && telephone) {
			changeAddressDelivery({
				city,
				district,
				extra: complement,
				name,
				number,
				phone: telephone,
				reference,
				state,
				street: address,
				zipcode: cep
			})
			setLoading(true);
			const noMaskCep = cepNoMask(cep);
			const order = await getOrder();
			const skus: Array<String> | undefined = order.products.map(
				(prod) => prod.sku
			);
			const config = await getAppConfig()
			const pgData = await getThisPluginspace();

			const locationsInLocalStore = localStorage.getItem('locations');
			let locations: any = []
			if (locationsInLocalStore) {
				locations = JSON.parse(locationsInLocalStore)
			}

			await api
				.post(
					`/api/variations/skuzipcode`,
					{
						zipcode: noMaskCep,
						skus: skus ? skus : [],
						restrictCep: config?.content.pdv.restrictCep ? config?.content.pdv.restrictCep : 'cep',
						noVerifyStock: true,
						locationId: (pgData && pgData.type === 'food') ? locations.find((el: any) => el.type == 'internal')?.id : null,
						latLng: (addressMapLocation && addressMapLocation.latLng && cepNoMask(addressMapLocation.cep) === noMaskCep)
							? addressMapLocation.latLng
							: null,
					},
					{
						headers: {
							Authorization: `Bearer ${await getToken()}`,
						},
					}
				)
				.then(async (response) => {
					if (response.data.length > 0) {
						setType("delivery");
						const newTelephone = telephoneNoMask(telephone);
						const newCep = cepNoMask(cep);

						const orderAddress = {
							address,
							cep: newCep,
							city,
							complement,
							district,
							name,
							number,
							reference,
							telephone: newTelephone,
							state,
							ibge
						}

						setOrderAddress(orderAddress);
						await findLocationId(orderAddress);
						if (goCustomer) {
							const tk = getTokenSeller();

							if (tk?.profile === "seller") {
								navigate(`/${pluginspace_id}/sellerCustomer`)
							} else {
								navigate(`/${pluginspace_id}/customer`)
							}


						}
						else window.location.reload();
					} else {
						Swal.fire({
							icon: "warning",
							title: "CEP Indisponível",
							text: "Este CEP não faz parte dessa área de entrega",
						});
					}
					setLoading(false);
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
				});
		} else {
			Swal.fire({
				icon: "error",
				title: "Erro",
				text: "Verifique se preencheu todos os campos",
			});
		}
	}

	async function findLocationId(orderAddress: any) {


		const newLocation = await getLocations()

		const location = newLocation.find(
			(location: LocationResponseType) =>
				location.code == "delivery"
		);
		setLocationId(location.id);
		if (goCustomer === true) {

			//setar novo endereço do customer

			changeCustomerAdress({ ...orderAddress, extra: orderAddress.complement })

			navigate(`/${pluginspace_id}/customer`);
		}



		/*
			Validação das localizações da loja para que busque do localStorage.
			Caso exista não precisa buscar novamente, mais indicado para o FOOD
	
			Essa função vai ser replicada para o ModalWithDrawl e ModalDelivery,
			uma vez que fazem a pesquisa da location para recuperar alguns dados.

			07/12/2023 - Bernnardo Pestana

			A função abaixo foi replicada dentro da PluginSpaceContext
			Uma vez que é utilizada em 3 momentos.
		
		*/
		/*
		const locationsInLocalStore = localStorage.getItem('locations');
		if (locationsInLocalStore) {

			const newLocation = JSON.parse(locationsInLocalStore)

			const location = newLocation.find(
				(location: LocationResponseType) =>
					location.code == "delivery"
			);
			setLocationId(location.id);
			if (goCustomer === true) {

				//setar novo endereço do customer
				changeCustomerAdress(cep)

				navigate(`/${pluginspace_id}/customer`);
			}

		} else {
			await api
				.get(`/api/location`, {
					headers: {
						Authorization: `Bearer ${await getToken()}`,
					},
				})
				.then(async (response) => {
					const location = response.data.data.find(
						(location: LocationResponseType) =>
							location.code == "delivery"
					);
					setLocationId(location.id);
					if (goCustomer === true) {

						//setar novo endereço do customer
						changeCustomerAdress(cep)

						navigate(`/${pluginspace_id}/customer`);
					}

				})
				.catch((err) => {
					console.log(err);
					Swal.fire({
						icon: "error",
						title: "Erro",
						text: "Erro ao encontrar loja",
					});
				});

		}
		*/
	}

	function changeTelephone(newPhone: string) {
		const phoneValidated =  newPhone.replaceAll("_", "")
		if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
			setMaskTelephone("(99) 99999-9999");
		} else {
			setMaskTelephone("(99) 9999-9999");
		}
	}


	async function isCepOk(cep: string) {
		return await api
			.get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
			.then((response) => {
				if (response.data.erro) return false;
				else return true;
			})
			.catch(() => {
				return false;
			});
	}

	async function findCep(cep: string, firstSearch?: boolean, noMapLocation?: boolean) {
		if (addressMapLocation && addressMapLocation.city && !noMapLocation) {
			setCity(addressMapLocation.city);
			setAddress(addressMapLocation.street);
			setDistrict(addressMapLocation.district);
			setState(addressMapLocation.state);
			setNumber(addressMapLocation.streetNumber);
			setCep(addressMapLocation.cep)
			return true
		} else {
			if (cep) {
				return await api
					.get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
					.then((response) => {
						if (response.data.erro) {
							setCity("");
							setAddress("");
							setDistrict("");
							setState("");
							setNumber('')
							setComplement('')
							setReference('')
							Swal.fire({
								icon: "warning",
								title: "CEP inválido!",
								text: "Verifique se o CEP foi digitado corretamente.",
							});
							return false;
						} else {
							if (response.data.ibge) {
								setIbge(response.data.ibge);
							} else if (customerAdress.ibge) {
								setIbge(customerAdress.ibge);
							} else {
								setIbge('');
							}

							if (response.data.localidade) {
								setCity(response.data.localidade);
							} else if (customerAdress.city) {
								setCity(customerAdress.city);
							} else {
								setCity('');
							}

							if (response.data.logradouro) {
								setAddress(response.data.logradouro);
							} else if (customerAdress.address) {
								setAddress(customerAdress.address);
							} else {
								setAddress('');
							}

							if (response.data.bairro) {
								setDistrict(response.data.bairro);
							} else if (customerAdress.district) {
								setDistrict(customerAdress.district);
							} else {
								setDistrict('');
							}

							if (response.data.uf) {
								setState(response.data.uf);
							} else if (customerAdress.state) {
								setState(customerAdress.state);
							} else {
								setState('');
							}


							if (firstSearch) {
								setNumber(customerAdress.number)

								setComplement(customerAdress.extra)

								setReference(customerAdress.reference)

							} else {
								setNumber('')

								setComplement('')

								setReference('')
							}


							setName(customerAdress.name)
							setTelephone(customerAdress.telephone)

							if (!firstSearch) {
								setNumber('')
								setReference('')
								setComplement('')
							}

							return true;
						}
					})
					.catch((erro) => {
						setCity("");
						setAddress("");
						setDistrict("");
						setState("");
						Swal.fire({
							icon: "warning",
							title: "CEP inválido!",
							text: "Verifique se o CEP foi digitado corretamente.",
						});
						return false;
					});
			}

		}
	}


	function clearFields() {
		if (lockHotelAddress) return;
		setCep("");
		setAddress("");
		setDistrict("");
		setCity("");
		setState("");
		setNumber("");
		setIbge("");
		setComplement("");
		setReference("");
		setName("");
		setTelephone("");
		setMaskTelephone("");
	}

	function applyHotelDeliveryPrefill() {
		const prefill = getHotelDeliveryPrefill();
		if (!prefill) return false;

		setLockHotelAddress(true);
		if (prefill.cep) setCep(prefill.cep);
		if (prefill.state) setState(prefill.state);
		if (prefill.city) setCity(prefill.city);
		if (prefill.district) setDistrict(prefill.district);
		if (prefill.street) setAddress(prefill.street);
		if (prefill.number) setNumber(prefill.number);
		if (prefill.complement) setComplement(prefill.complement);
		if (prefill.reference) setReference(prefill.reference);
		if (prefill.name) setName(prefill.name);
		if (prefill.telephone) {
			setTelephone(prefill.telephone);
			changeTelephone(prefill.telephone);
		}
		return true;
	}

	async function getAddressLocaStorage() {
		setLoading(true);
		const hotelPrefillApplied = applyHotelDeliveryPrefill();
		if (hotelPrefillApplied) {
			const prefill = getHotelDeliveryPrefill();
			// Se veio só CEP, completa via ViaCEP sem liberar edição
			if (prefill?.cep && (!prefill.street || !prefill.city || !prefill.district)) {
				await findCep(prefill.cep, true);
				if (prefill.number) setNumber(prefill.number);
				if (prefill.complement) setComplement(prefill.complement);
				if (prefill.reference) setReference(prefill.reference);
				if (prefill.name) setName(prefill.name);
			}
			setLoading(false);
			return;
		}

		const customerAddressLocal = getAddressDelivery();
		if (addressMapLocation && addressMapLocation.cep) {
			await findCep('', true)
			if (customerAddressLocal) {
				setName(customerAddressLocal.name);
				setTelephone(customerAddressLocal.phone);
			}
		} else if (customerAddressLocal && !customerAdress) {
			findCep(customerAddressLocal.zipcode);
			setCep(customerAddressLocal.zipcode);
			setAddress(customerAddressLocal.street);
			setDistrict(customerAddressLocal.district);
			setCity(customerAddressLocal.city);
			setState(customerAddressLocal.state);
			setNumber(customerAddressLocal.number);
			setComplement(customerAddressLocal.extra);
			setReference(customerAddressLocal.reference);
			setName(customerAddressLocal.name);
			setTelephone(customerAddressLocal.phone);
		} else {
			if (customerAdress) {
				await findCep(customerAdress.cep, true)
				setCep(customerAdress.cep)
			}
		}
		const customer = await orderContext.getCustomer()
		if (customer.telephone) setTelephone(customer.telephone)
		if (customer.name) setName(customer.name)

		setLoading(false);
	}

	function setSeller() {
		try {
			const tk = getTokenSeller();

			if (tk?.profile === "seller") {
				setIsSeller(true)
			}

		} catch (error) {

		}
	}

	useEffect(() => {
		setSeller()
		getAddressLocaStorage()
	}, [])


	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={() => setIsOpen(false)}
			className="modal-delivery"
			contentLabel="Endereço para entrega"
			overlayClassName="overlay-modal"
			ariaHideApp={false}
		>
			<div className="modal-delivery-content">
				<div className="modal-delivery-body">
					<div className="title">
						<h2>Endereço para entrega</h2>
						<svg
							onClick={() => setIsOpen(false)}
							width="17"
							height="17"
							viewBox="0 0 17 17"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
								fill="#636363"
							/>
						</svg>
					</div>
					<div className="input_div">
						<label>CEP *</label>
						<InputMask
							mask="99999-999"
							placeholder="CEP XXXXX-XXX"
							type="text"
							value={cep}
							disabled={lockHotelAddress}
							onChange={(event) => {
								if (lockHotelAddress) return;
								setCep(event.target.value);
							}}
							onBlur={(event) => {
								if (lockHotelAddress) return;
								if (cep[0] === "_") {
									setAlarmCep(true);
								} else {
									findCep(event.target.value, undefined, true);
									setAlarmCep(false);
								}
							}}
						/>
						{alarmCep && <p className="alarm-text">Informe o CEP</p>}
					</div>
					<div className="input_div">
						<label>Estado *</label>
						<input
							disabled
							placeholder="Estado"
							type="text"
							value={state}
							onChange={(event) => setState(event.target.value)}
							onBlur={() =>
								city === ""
									? setAlarmState(true)
									: setAlarmState(false)
							}
						/>
						{alarmState && (
							<p className="alarm-text">Informe o Estado</p>
						)}
					</div>


					<div className="input_div">
						<label >Cidade *</label>
						<input
							disabled
							placeholder="Cidade"
							type="text"
							value={city}
							onChange={(event) => setCity(event.target.value)}
							onBlur={() =>
								city === ""
									? setAlarmCity(true)
									: setAlarmCity(false)
							}
						/>
						{alarmCity && (
							<p className="alarm-text">Informe a Cidade</p>
						)}
					</div>
					<div className="input_div">
						<label >Bairro *</label>
						<input
							placeholder="Bairro"
							type="text"
							value={district}
							disabled={lockHotelAddress}
							onChange={(event) => {
								if (lockHotelAddress) return;
								setDistrict(event.target.value);
							}}
							onBlur={() =>
								district === ""
									? setAlarmDistrict(true)
									: setAlarmDistrict(false)
							}
						/>
						{alarmDistrict && (
							<p className="alarm-text">Informe o Bairro</p>
						)}
					</div>

					<div className="input_div">
						<label htmlFor="">Logradouro (Rua, Av, Praça, etc...) *</label>
						<input
							placeholder="Logradouro (rua, avenida, praça, etc...)"
							type="text"
							value={address}
							disabled={lockHotelAddress}
							onChange={(event) => {
								if (lockHotelAddress) return;
								setAddress(event.target.value);
							}}
							onBlur={() =>
								address === ""
									? setAlarmAddress(true)
									: setAlarmAddress(false)
							}
						/>
						{alarmAddress && (
							<p className="alarm-text">Informe o Endereço</p>
						)}
					</div>
				

				
					
					<div className="row-input">
						<div className="div_input_column">
							<label>Número *</label>
							<input
								placeholder="Número"
								type="text"
								value={number}
								disabled={lockHotelAddress}
								onChange={(event) => {
									if (lockHotelAddress) return;
									setNumber(
										event.target.value
											.replace(/[^0-9.]/g, "")
											.replace(/(\..*?)\..*/g, "$1")
									);
								}}
								onBlur={() =>
									number === ""
										? setAlarmNumber(true)
										: setAlarmNumber(false)
								}
							/>
							{alarmNumber && (
								<p className="alarm-text">Informe o Número</p>
							)}
						</div>
						<div className="div_input_column">
							<label>Compl (Ap, Bloco, Quadra ...) *</label>
							<input
								placeholder={isSeller ? '(Exemplo: casa, trabalho, etc)' : 'Complemento'}
								type="text"
								value={complement}
								disabled={lockHotelAddress}
								onChange={(event) => {
									if (lockHotelAddress) return;
									setComplement(event.target.value);
								}}
								onBlur={() => {
									if (isSeller) {
										complement === ""
											? setAlarmComplement(true)
											: setAlarmComplement(false)
									}

								}
								}
							/>
							{alarmComplement && isSeller && (
								<p className="alarm-text">Informe o Nome do endereço *</p>
							)}
						</div>
					</div>
					<div className="input_div">
						<label>Referência</label>
						<input
							placeholder="Ponto próximo de referência"
							type="text"
							value={reference}
							disabled={lockHotelAddress}
							onChange={(event) => {
								if (lockHotelAddress) return;
								setReference(event.target.value);
							}}
						/>
					</div>
					<div className="input_div">
						<label>Quem vai receber *</label>
						<input
							placeholder="Nome de quem vai receber"
							type="text"
							value={name}
							disabled={lockHotelAddress && !!name}
							onChange={(event) => {
								if (lockHotelAddress && name) return;
								setName(event.target.value);
							}}
						/>
						{alarmName && (
							<p className="alarm-text">
								Informe o nome de quem vai receber
							</p>
						)}
					</div>
					<div className="input_div">
						<label>Telefone de entrega *</label>
						<InputMask
							mask={maskTelephone}
							placeholder="DDD + Telefone de entrega"
							type="text"
							value={telephone}
							onBeforeInputCapture={(event) =>
								changeTelephone(event.currentTarget.value)
							}
							onChange={(event) => setTelephone(event.target.value)}
							onBlur={() =>
								telephone[1] === "_"
									? setAlarmTelephone(true)
									: setAlarmTelephone(false)
							}
						/>
						{alarmTelephone && (
							<p className="alarm-text">Informe o telefone *</p>
						)}
					</div>

					<div style={{
							display:'flex',
							justifyContent:"end",
							marginTop:'0.5rem'
						}}>
						<span style={{
							color:'red',
							fontSize:"10px"
						}}>* dados obrigatórios</span>
					</div>
					<div className="button-modal">
						{loading ? (
							<ReactLoading
								type="spinningBubbles"
								color="#636363"
								height={40}
								width={40}
							/>
						) : (

							<>
								< div className="main-buttons">
									<div>
										<MainButton
											color={fontButton ? fontButton : "#636363"}
											backgroundColor={
												backgroundButton
													? backgroundButton
													: "#EAEAEA"
											}
											text="Continuar"
											onClick={() => goToCustomer()}
											className="button-modal-continue"
										/>
									</div>
									<div className="button-modal-clear">
										{!lockHotelAddress && (
											<span onClick={() => clearFields()} >Limpar campos </span>
										)}
									</div>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</Modal >
	);
}
